(function(){
    angular
        .module('appback')
        .directive('ngUbicacionstock', ubicacionStock);
        ubicacionStock.$inject = ['PedidosService','StockService','$timeout', 'Upload'];
        function ubicacionStock(PedidosService,StockService,$timeout, Upload){
            return {
	            //require: 'ngModel',
              templateUrl: '/backend/pedidos/template?name=ubicacionstock.twig',
		        scope: {
                    pc:'=',
                },
            	link: function (scope, element, $attrs) {
		            return $timeout(function () {
                        scope.stocksPorMaterial = {};

                        scope.init = function(){
                            function loadStock(){
                                PedidosService.checkStockPendiente(scope.pc.pedidoActivoID,function(stocksPedido){
                                    if(stocksPedido.stock_pendiente_insertar){
                                        $timeout(loadStock, 5000);  
                                    }else{
                                        scope.pc.pedidoActivo.stocks = stocksPedido.stocks;
                                        scope.pc.pedidoActivo.stock_pendiente_insertar = false;
                                        scope.pc.pedidoActivo.ubicacion_completada = stocksPedido.ubicacion_completada;
                                        scope.initStocks();
                                    }
                                });
                            }
                            loadStock();
                        }

                        scope.initStocks = function(){
                            scope.stocksPorMaterial = {};
                            angular.forEach(scope.pc.pedidoActivo.stocks, function(stock) {
                                if (!scope.stocksPorMaterial[stock.material.id]) {
                                    scope.stocksPorMaterial[stock.material.id] = {
                                        material: stock.material,
                                        stocks: []
                                    };
                                }
                                scope.stocksPorMaterial[stock.material.id].stocks.push(stock);
                            });
                        }
                        scope.init();

                        scope.guardarUbicacion = function(stock){
                            console.log("guardando ubicaciones", stock);
                            PedidosService.guardarUbicacion(stock, scope.pc.pedidoActivoID, function(data){
                                if(data.pedido){
                                    scope.pc.pedidoActivo = data.pedido;
                                    scope.initStocks();
                                }
                            });
                        }
			        });
		        }
          }
      }
})();